





/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams (params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}


export function dateFormatter(str){//默认返回yyyy-MM-dd HH-mm-ss
    var hasTime = arguments[1] != false ? true : false;//可传第二个参数false，返回yyyy-MM-dd
    var d = str ? new Date(str) : new Date();
    var year = d.getFullYear();
    var month = (d.getMonth()+1)<10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1);
    var day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
    var hour = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
    var minute = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
    var second = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();
    if(hasTime){
        return [year, month, day].join('-') + " " + [hour, minute, second].join(':');
    }else{
        return [year, month, day].join('-');
    }
}
/**
 * @param {string} str - 待编码字符串
 * @param {number} offset - 偏移量（增强自定义性）
 * @returns {string} 编码结果
 */
export function encodeChinese(str, offset = 100) {
  return Array.from(str).map(char => 
    (char.charCodeAt(0) + offset).toString(16)
  ).join('-');
}

/**
 * 自定义解码器
 * @param {string} encodedStr - 编码后的字符串
 * @param {number} offset - 需与编码时一致
 * @returns {string} 原始汉字
 */
export function decodeChinese(encodedStr, offset = 100) {
  return encodedStr.split('-').map(code => 
    String.fromCharCode(parseInt(code, 16) - offset)
  ).join('');
}
/**
 * 金额转化成大写
 * @param {number} n - 输入的金额数字
 * @returns {string} 大写
 */
export function dealBigMoney (n) {
    if (n === 0)
        return "零";
    n = n.replace(/,/g, ""); // 先清除千分位逗号，修复格式问题
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n))
        return "";
    var unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";
    n += "00";
    var p = n.indexOf('.');
    if (p >= 0)
        n = n.substring(0, p) + n.substr(p + 1, 2);
    unit = unit.substr(unit.length - n.length);
    for (var i = 0; i < n.length; i++)
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
    
    return str
        .replace(/零(仟|佰|拾|角)/g, "零")
        .replace(/(零)+/g, "零")
        .replace(/零(万|亿|元)/g, "$1")
        .replace(/(亿)万/g, "$1")
        .replace(/^元零?|零分/g, "")
        .replace(/元$/g, "元整")        // 无角分 → 元整
        .replace(/角$/g, "角整")        // 只有角无分 → 角整
}

